// src/components/CustomRadio.jsx
import { styled } from "@mui/material/styles"
import { Radio } from "@mui/material"

const CustomRadio = styled(Radio)(({ theme }) => ({
  color: "#004f7d",
  "&.Mui-checked": {
    color: "#004f7d",
  },
}))

export default CustomRadio
